import { UserManager } from './TripUserManager';

export default UserManager;
